import { FieldValue } from "firebase/firestore";

export type Project = {
    name: string;
    id: string;
    maps: string[];
    units: string[];
    buildings: string[];
    resource: string[];
    lastUpdated: FieldValue;
    created: FieldValue;
};

export type MapType = {
    id: string;
    grid: string;
    lastUpdated: FieldValue;
    name: string;
    projectId: string;
    type: "map";
};

export enum UNIT_ATTACK_TYPE {
    RANGED,
    MELEE,
}

export type Unit = {
    projectId: string;
    id: string;
    lastUpdated?: FieldValue;
    name: string;
    texture: string;
    hp: number;
    attack: number;
    defense: number;
    attackType: UNIT_ATTACK_TYPE;
    weaknesses: UNIT_ATTACK_TYPE[];
    resourcesCollectable: string[]; // user defined
    buildingsBuildable: string[]; // user defined
    type: "unit";
};

export enum CORE_TYPE {
    UNIT,
    RESOURCE,
}

type PRODUCTION_COST = {
    type: CORE_TYPE;
    quantity: number;
    coreId: string;
};

export type PRODUCTION = {
    cost: PRODUCTION_COST[]; // an array of user-defined resources
    id: string; // the ID from the unit and/or resource
    duration: number; // how long it takes to build
};

export type Building = {
    projectId: string;
    id: string;
    name: string;
    texture: string;
    integrity: number;
    lastUpdated?: FieldValue;
    resourceInType: string[]; // user defined
    outputType: CORE_TYPE;
    coreId: string; // user defined core element ID
    production: PRODUCTION[];
    type: "building";
};

export type Resource = {
    projectId: string;
    name: string;
    id: string;
    lastUpdated: FieldValue;
    texture: string;
    type: "resource";
};

export type Trigger = {
    key: string;
    label: string;
    comparitor: string;
    amount?: number;
}

export type ArmyUnit = {
    unit: Unit;
    count: number;
    id: string;
}

export type ArmyAttackAction = {
    type: "army_attack";
    label: "Army Attack";
    units: ArmyUnit[];
    id: string;
}

export type Action = ArmyAttackAction;

export type GameEvent = {
    triggers: Trigger[];
    actions: Action[];
}